import {ROUTES} from '@/config/constants'
import {ErrorContent} from '@/pages/Errors/components/ErrorContent'
import {useNavigate} from 'react-router-dom'

export default function SessionExpired(): React.JSX.Element {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(ROUTES.HOME)
    window.location.reload()
  }

  return <ErrorContent errorType="SESSION_EXPIRED" onClick={onClick} />
}
